import React from 'react';

import Flex, {Box} from 'components/Flex';
import Text from 'components/Text';

import Button from 'components/Button';
import VisuallyHidden from 'components/VisuallyHidden';

function ButtonField(props) {
	const {selectedValue, readout, title, children, ...otherProps} = props;

	return (
		<Flex>
			<Box grow shrink pr="m">
				<Text bold>{title}</Text>
				<br />
				{readout ? readout(selectedValue) : selectedValue}
			</Box>
			<Box>
				<Button variant="primary" {...otherProps} size="medium">
					{children}
					<VisuallyHidden>{title}</VisuallyHidden>
				</Button>
			</Box>
		</Flex>
	);
}

export default ButtonField;
